var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-avatar',{attrs:{"icon":_vm.icon,"size":_vm.size,"color":_vm.color,"text-color":_vm.textColor,"font-size":_vm.fontSize,"rounded":_vm.rounded}})}
var staticRenderFns = []

export { render, staticRenderFns }